(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/collections/grassroot-list.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/collections/grassroot-list.js');
(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.collections.GrassrootList = Backbone.Collection.extend({
    initialize: function(models, options) {
      this.myReceiver = options.myReceiver || {};
      this.url = options.url;
      var self = this;
      this.listenTo(this.myReceiver, 'add reset', function() {
        _.each(self.myReceiver.models, function(myReceiver) {
          _.find(self.models, function(listModel) {
            if (listModel.get('id') === myReceiver.get('id')) {
              listModel.set('myReceiver', true);
              return true;
            }
            return false;
          });
        });
      });
      this.listenTo(this.myReceiver, 'remove reset', function() {
        _.each(self.models, function(listModel) {
          if (listModel.get('myReceiver')) {
            if (
              !_.find(self.myReceiver.models, function(myReceiver) {
                return listModel.get('id') === myReceiver.get('id');
              })
            ) {
              listModel.set('myReceiver', false);
            }
          }
        });
      });
    },
    fetch: function(options) {
      options = options || {};
      var fetchOptions = {
        error: function(collection, response) {
          svs.grassroots_logger.error('Error in fetching users receivers: ' + JSON.stringify(response));
        },
        success: function() { }
      };
      if (!Object.prototype.hasOwnProperty.call(options, 'error')) {
        options.error = fetchOptions.error;
      }
      return Backbone.Collection.prototype.fetch.call(this, options);
    },
    parse: function(response) {
      _.each(response.categories[0].topSelections, function(receiver) {
        receiver.topselectionPoints = true;
        receiver.topselection = true;
      });
      return response.categories[0].topSelections;
    },

    checkModel: function(model) {
      var tmpModel = model;
      if (typeof model === 'number') {
        _.find(this.models, function(internalModel) {
          if (internalModel.get('id') === model) {
            tmpModel = internalModel;
            return true;
          }
          return false;
        });
      }
      return tmpModel;
    },
    addSupport: function(model, name, el) {
      model = this.checkModel(model);
      this.myReceiver.addSupport(model, el);
    },
    removeSupport: function(model) {
      model = this.checkModel(model);
      this.myReceiver.removeSupport(model);
    },
    replaceSupport: function(
      receiverToAddId,
      receiverToRemoveId,
      receiverToAddName
    ) {
      this.myReceiver.replaceSupport(
        receiverToAddId,
        receiverToRemoveId,
        receiverToAddName
      );
    },
    fetchMoreItems: function() {
      this.fetch({
        remove: false,
        data: $.param({
          numRows: 5,
          offset: this.length + 1
        }),
        error: function(collection, response) {
          svs.ui.loader.hide();
          svs.grassroots.helpers.dialog.errorToaster({
            title: 'Fel',
            text: 'Kunde inte hämta fler föreningar, försök igen.'
          });
          svs.grassroots_logger.error('Error in fetching users receivers: ' + JSON.stringify(response));
        },
        success: function() {
          svs.ui.loader.hide();
        }
      });
    }
  });
})(Backbone, _, svs);


 })(window);